import React from "react";
import { Box, Typography, Link, useMediaQuery } from "@mui/material";
import {
  Facebook,
  Google,
  LinkedIn,
  YouTube,
  Pinterest,
} from "@mui/icons-material";
import logo from "../../assets/logo_renovations.jpg";
import "./Footer.css";

const Footer = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box className="footer" marginTop={10}>
      <Box className="footer-content">
        <Box className="footer-logo">
          <img
            src={logo}
            alt="logo"
            style={{ borderRadius: "20px" }}
            height={150}
          />
        </Box>

        <Box
          className="footer-text"
          sx={{
            marginLeft: isMobile ? "0" : "100px",
            marginBottom: isMobile ? "20px" : "30px",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              textTransform: "uppercase",
              fontSize: "16px",
              marginBottom: "15px",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            REMODELING THE GREATER Chicago AREA
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "30px",
              width: { xs: "100%", md: "80%" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            Proudly serving Serving Chicago area and Chicago suburbs.
          </Typography>
        </Box>
        <Box className="footer-socials">
          <Link href="#">
            <Facebook />
          </Link>
          <Link href="#">
            <Google />
          </Link>
          <Link href="#">
            <LinkedIn />
          </Link>
          <Link href="#">
            <YouTube />
          </Link>
          <Link href="#">
            <Pinterest />
          </Link>
        </Box>
      </Box>
      <Box className="footer-bottom">
        <Typography
          variant="body2"
          sx={{ textAlign: { xs: "center", md: "left" }, width: "100%" }}
        >
          Copyright © 2024 Pro Renovations LLC Construction Inc., All Rights
          Reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
